import { useState } from "react";
import { Button } from "react-bootstrap";

import { GenerateApiKeyForm } from "../forms/GenerateApiKeyForm";

const GenerateApiKey = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleOpen = () => {
    setShow(true);
  };

  return (
    <>
      {show && <GenerateApiKeyForm onCancel={handleClose} />}

      <Button onClick={handleOpen} className="fw-bold flex-shrink-0 ms-md-auto">
        Generate API key
      </Button>
    </>
  );
};

export default GenerateApiKey;
